import axios from "axios";
// https://alumnisocialcornerapi.herokuapp.com/
// http://localhost:5000/api

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: "https://alumnisocialcornerapi.herokuapp.com/api",
});
if (localStorage.token) {
  api.defaults.headers.common["auth-token"] = localStorage.getItem("token");
}

export default api;
